export const url = "/api/v1.0/product";

export const cache = {
    "expire_type" : "page"
};